import React from "react";
import Box from "@mui/material/Box";
export const Img =
    ({ src, alt = "", children, ...props }) => {
        return <Box component="img"  {...props} src={src} alt={alt} />;
};

export default Img;